import React from 'react'
import { CommonFilters } from "@components"
import { offices, reports, searchID, sites } from "@signals"
import useAnalyzerRatingFilters from "Pages/AnalyzersV2/Rating/@hooks/useFilters"
import { BACKEND_APIS } from "@constants"


export default function RatingFilters() {

	const { errors, isValid, schema, onSubmit } = useAnalyzerRatingFilters()
	const officePickupID = offices.value
	const reportExecutionID = reports.value
	const usedSearchID = searchID.value
	const sitesID = sites.value
	const hasOfficeOrSearch = (!!officePickupID && !!reportExecutionID) || !!usedSearchID
	return <CommonFilters
		components={{
			offices: !!reportExecutionID,
			sites: hasOfficeOrSearch,
			tiers: hasOfficeOrSearch,
			providers: hasOfficeOrSearch,
		}}
		compProps={{
			offices: {
				urlAjax: `${BACKEND_APIS.EXECUTION_INFO}/offices`,
				error: errors.officePickupID,
				notAsync: true,
				filters: {
					idReportExecution: reportExecutionID,
					selected: officePickupID,
					getDirectSites: false
				},
			},
			sites: {
				multiple: true,
				filters: {
					officePickupID: officePickupID,
					reportExecutionID: reportExecutionID,
					searchID: usedSearchID,
					getDirectSites: false
				}
			},
			tiers: {
				filters: {
					officePickupID: officePickupID,
					reportExecutionID: reportExecutionID,
					searchID: usedSearchID,
					getDirectSites: false,
					siteID: sitesID
				}
			},
			providers: {
				multiple: true,
				filters: {
					officePickupID: officePickupID,
					reportExecutionID: reportExecutionID,
					searchID: usedSearchID,
					getDirectSites: false,
					siteID: sitesID
				},
			},
		}}
		isValid={isValid}
		onSubmit={onSubmit}
		schema={schema}
	/>
}